module.exports = function () {
  /**
  * @file core/filter.js
  * 具体端能力判断、过滤逻辑
  * 支持的platform必须配置，无特殊配置可为空；不配置的platform则不支持
  * @author gaojiexuan@baidu.com
  */
  return {};
}();